import { baseApi } from "./baseApi";

export const messageApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({

    getConversation: builder.query({
      query: (partnerId) => `/coach/messages/${partnerId}`,
      providesTags: (result, error, partnerId) => [
        { type: "Conversation", id: partnerId },
      ],
      transformResponse: (response) => {
        if (Array.isArray(response))       return response;
        if (Array.isArray(response?.data)) return response.data;
        return [];
      },
    }),

    // Alias historique (même endpoint) — gardé pour compatibilité éventuelle
    getConversationCoach: builder.query({
      query: (partnerId) => `/coach/messages/${partnerId}`,
      providesTags: (result, error, partnerId) => [
        { type: "Conversation", id: partnerId },
      ],
      transformResponse: (response) => {
        if (Array.isArray(response))       return response;
        if (Array.isArray(response?.data)) return response.data;
        return [];
      },
    }),

    // POST /coach/messages
    sendCoach: builder.mutation({
      query: ({ receiver_id, contenu }) => ({
        url: "/coach/messages",
        method: "POST",
        body: { receiver_id, contenu },
      }),
      invalidatesTags: (result, error, { receiver_id }) => [
        { type: "Conversation", id: receiver_id },
      ],
    }),

    // Alias sendMessage utilisé par DiscussionPage (coach)
    sendMessage: builder.mutation({
      query: ({ receiver_id, contenu, content }) => ({
        url: "/coach/messages",
        method: "POST",
        body: { receiver_id, contenu: contenu ?? content },
      }),
      invalidatesTags: (result, error, { receiver_id }) => [
        { type: "Conversation", id: receiver_id },
      ],
    }),

    // GET /stagiaire/messages/{coachId}
    getConversationStagiaire: builder.query({
      query: (coachId) => `/stagiaire/messages/${coachId}`,
      providesTags: (result, error, coachId) => [
        { type: "Conversation", id: coachId },
      ],
      transformResponse: (response) => {
        if (Array.isArray(response))       return response;
        if (Array.isArray(response?.data)) return response.data;
        return [];
      },
    }),

    // POST /stagiaire/messages
    sendStagiaire: builder.mutation({
      query: ({ receiver_id, contenu }) => ({
        url: "/stagiaire/messages",
        method: "POST",
        body: { receiver_id, contenu },
      }),
      invalidatesTags: (result, error, { receiver_id }) => [
        { type: "Conversation", id: receiver_id },
      ],
    }),

  
    getConversationList: builder.query({
      queryFn: () => ({ data: [] }),
    }),

    markConversationAsRead: builder.mutation({
      queryFn: () => ({ data: { success: true } }),
    }),

    markMessageAsRead: builder.mutation({
      queryFn: () => ({ data: { success: true } }),
    }),

    getUnreadStats: builder.query({
      queryFn: () => ({ data: { totalUnread: 0, unread_total: 0 } }),
    }),
  }),
});

export const {
  useGetConversationQuery,
  useGetConversationCoachQuery,
  useSendCoachMutation,
  useSendMessageMutation,
  useGetConversationStagiaireQuery,
  useSendStagiaireMutation,
  useGetConversationListQuery,
  useMarkConversationAsReadMutation,
  useMarkMessageAsReadMutation,
  useGetUnreadStatsQuery,
} = messageApi;